import React from 'react';
import PropTypes from 'prop-types';

const ToggleSwitch = ({
  value,
  onChange,
  label,
  labelLeft,
  labelRight,
  className = '',
  disabled = false,
  size = 'md',
}) => {
  const sizes = {
    sm: { track: 'tw-h-4 tw-w-8',   knob: 'tw-h-3 tw-w-3',   on: 'tw-translate-x-4' },
    md: { track: 'tw-h-5 tw-w-9',   knob: 'tw-h-4 tw-w-4',   on: 'tw-translate-x-4' },
    lg: { track: 'tw-h-6 tw-w-11',  knob: 'tw-h-5 tw-w-5',   on: 'tw-translate-x-5' },
  };

  const s = sizes[size] || sizes.md;

  return (
    <div className={`tw-inline-flex tw-items-center tw-gap-2 ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''} ${className}`}>
      {labelLeft && (
        <span className="tw-text-sm tw-text-gray-600 tw-select-none">{labelLeft}</span>
      )}

      <button
        type="button"
        role="switch"
        aria-checked={value}
        disabled={disabled}
        onClick={() => !disabled && onChange(!value)}
        className={[
          'tw-relative tw-inline-flex tw-shrink-0 tw-items-center tw-rounded-xl tw-p-0',
          'tw-transition-colors tw-duration-200 tw-ease-in-out',
          'tw-border-0',
          'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-blue-500 focus-visible:tw-ring-offset-2',
          disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer',
          value ? 'tw-bg-blue-500' : 'tw-bg-gray-300',
          s.track,
        ].join(' ')}
      >
        <span
          className={[
            'tw-pointer-events-none tw-absolute tw-top-1/2 tw-left-0.5 tw--translate-y-1/2',
            'tw-rounded-xl tw-bg-white',
            'tw-shadow-sm tw-ring-0',
            'tw-transition-transform tw-duration-200 tw-ease-in-out',
            value ? s.on : 'tw-translate-x-0',
            s.knob,
          ].join(' ')}
        />
      </button>

      {(labelRight || label) && (
        <span className="tw-text-sm tw-text-gray-700 tw-select-none">{labelRight || label}</span>
      )}
    </div>
  );
};

ToggleSwitch.propTypes = {
  value:      PropTypes.bool.isRequired,
  onChange:   PropTypes.func.isRequired,
  label:      PropTypes.string,
  labelLeft:  PropTypes.string,
  labelRight: PropTypes.string,
  className:  PropTypes.string,
  disabled:   PropTypes.bool,
  size:       PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default ToggleSwitch;
